import { render, staticRenderFns } from "./PretrainBase.vue?vue&type=template&id=737ad48e&scoped=true&"
import script from "./PretrainBase.vue?vue&type=script&lang=js&"
export * from "./PretrainBase.vue?vue&type=script&lang=js&"
import style0 from "./PretrainBase.vue?vue&type=style&index=0&id=737ad48e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737ad48e",
  null
  
)

export default component.exports